import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import NavBarMarket from "../components/NavBar/NavBar";
import { find, get } from "lodash";
import { CONTENTFUL_ENTRIES } from "../constants/ContentConstats";

const RootLayout = () => {
  const { country } = useParams<{ country: string }>();
  const [navbarData, setNavbarData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNavbar = async () => {
      if (!country) return;

      const entryId =
        CONTENTFUL_ENTRIES[country as keyof typeof CONTENTFUL_ENTRIES]
          ?.headerPropi;

      if (!entryId) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `https://cdn.contentful.com/spaces/2s65zqhp8au5/entries/${entryId}`,
          {
            headers: {
              Authorization:
                "Bearer y0IYxPnHITMQAbl3NERyBLUdvMzb8p3ON1tLtlDRna0",
            },
          }
        );

        if (!response.ok) throw new Error("Error al cargar navbar");

        const data = await response.json();
        setNavbarData(data.fields);
      } catch (error) {
        console.error("Error cargando navbar:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNavbar();
  }, [country]);

  const isTransparent = find(
    get(navbarData, "transparent", []),
    { link: "" }
  );

  return (
    <>
      {!loading && (
        <NavBarMarket
          layoutData={navbarData}
          isTransparent={!!isTransparent}
        />
      )}

      <Outlet />
    </>
  );
};

export default RootLayout;
